/**
 * Stylesheet injection.
 *
 * Every UI surface ships its own CSS next to the code that builds it, so there is one place to
 * look for a colour or a size, and a surface that is torn down takes its styles with it.
 */

/** Appends a stylesheet to the document. Returns a function that removes it again. */
export function injectCss(css: string): () => void {
  const style = document.createElement('style');
  style.textContent = css;
  document.head.append(style);
  return (): void => {
    style.remove();
  };
}
